export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const config = useRuntimeConfig();
    const gtmConfig = config.public.gtm;

    if (gtmConfig && gtmConfig.id) {
      const gtmScript = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=${
          gtmConfig.auth || ""
        }&gtm_preview=${
        gtmConfig.env || ""
      }&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmConfig.id}');
      `;

      const scriptElement = document.createElement("script");
      scriptElement.type = "text/plain";
      scriptElement.setAttribute("data-usercentrics", "Google Tag Manager");
      scriptElement.textContent = gtmScript;

      document.head.appendChild(scriptElement);
    }
  }
});
